import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "72",
  height: "72",
  viewBox: "0 0 72 72",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("title", null, "icon-ui-nav-followers", -1),
    _createElementVNode("g", { "fill-rule": "nonzero" }, [
      _createElementVNode("path", { d: "M55 8v56.048a5 5 0 0 0 10 0V8a5 5 0 0 0-10 0zM20.584 52H42.5a4 4 0 1 0 0-8H20.164l5.399-6.427a4 4 0 0 0-6.126-5.146l-10.5 12.5a3.986 3.986 0 0 0-.93 2.823c-.061.99.242 2.004.93 2.823l10.5 12.5a4 4 0 0 0 6.126-5.146L20.584 52z" })
    ], -1)
  ]))]))
}
export default { render: render }